/**
 * Thin wrapper over @mb-group/seo#applySeo. Builds a SeoMeta (title/description/
 * canonical + hreflang for the current route in each locale it exists in) and applies it to
 * the document head. Called by every view.
 */
import { applySeo } from "@mb-group/seo";
import type { AppContext } from "./context.js";

export interface PageSeoInput {
	title: string;
	description: string;
	noindex?: boolean;
}

export function applyPageSeo(ctx: AppContext, input: PageSeoInput): void {
	if (typeof window === "undefined") return;
	const origin = window.location.origin;
	// No alternate for a language the page has no version in (router.hrefIn).
	const hreflang = (["pl", "en"] as const).flatMap((locale) => {
		const href = ctx.router.hrefIn(locale);
		return href ? [{ locale, url: origin + href }] : [];
	});
	const canonicalUrl = origin + window.location.pathname;

	applySeo(
		{
			title: input.title,
			description: input.description,
			noindex: input.noindex ?? false,
			hreflang,
			canonicalUrl,
		},
		{ locale: ctx.locale(), url: window.location.href },
	);
}
